<div class="fill-container" [ngClass]="{ shadow: shadow }" id="fill-container">
    @if (selectedImage) {
        <img class="fill-background-image" [ngSrc]="selectedImage" fill [alt]="alt" priority />
    }
    <div class="fill-content">
        <ng-content />
    </div>
</div>
